import { request } from 'umi'; 
import { APIConfig } from '@/config/common';

export async function GetDataList(params?: any)
{
	return request(`${APIConfig.APIPrefix}/sys/code/list`, {
		method: 'POST',
		data: {
			...params
		},
    
	});

} 
export async function SaveData(params?: any)
{
	if(params?.id){
		return request(`${APIConfig.APIPrefix}/sys/code/update`, {
			method: 'POST',
			data: {
				...params
			},
      
		});
  
	}
	return request(`${APIConfig.APIPrefix}/sys/code/add`, {
		method: 'POST',
		data: {
			...params
		},
    
	});

}
export async function DeleteData(params?: any)
{
	return request(`${APIConfig.APIPrefix}/sys/code/delete`, {
		method: 'POST',
		data: {
			...params
		},
    
	});

}

export async function GetSsxTreeList(params?: any)
{
	return request(`${APIConfig.APIPrefix}/sys/code/ssxtreelist`, {
		method: 'POST',
		data: {
			...params
		},
    
	});

} 
